import { ErrorMessage } from 'formik'
import React, { useState } from 'react'
import { Form as frm, InputGroup } from 'react-bootstrap'
import FormikControl from '../../components/FormikControl'
import ReactSelect from '../../components/ReactSelect'
import TextError from '../../components/TextError'
import CustomToast from '../../components/Toast/CustomToast'
import {
  fetchCalculation,
  prepareDisplayCalculationData,
  showToast
} from '../../lib/AllGlobalFunction'
import {
  chargesIn,
  currencyIcon,
  isAllowPriceVariant,
  isAllowWarehouseManagement,
  isMarginOnProductLevel
} from '../../lib/AllStaticVariables'
import { _percentageRegex_ } from '../../lib/Regex'
import {
  calculateCommission,
  calculatePrices
} from './productUtils/helperFunctions'
import { handleSizeValuePriceVariant } from './productUtils/productFunctions'

const PricingDetails = ({
  values,
  allState,
  setFieldValue,
  setCalculation,
  calculation,
  resetForm,
  errors,
  touched
}) => {
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })

  const updateProductPrices = (values) => {
    let productPrices = values?.productPrices ?? []

    fetchCalculation(
      'Product/DisplayCalculation',
      prepareDisplayCalculationData(values),
      (data) => {
        setCalculation({
          ...calculation,
          displayCalculation: data
        })
      }
    )

    return productPrices.map((product) => {
      if (
        values?.isSizeWisePriceVariant &&
        product?.sizeID !== values?.sizeValueId
      ) {
        return product
      }

      return {
        ...product,
        mrp: values?.mrp,
        sellingPrice: values?.sellingPrice,
        discount: values?.discount,
        marginCost: values?.marginCost,
        marginIn: values?.marginIn,
        marginPercentage: values?.marginPercentage
      }
    })
  }

  const updateCommission = async (values) => {
    let { marginIn, marginCost, marginPercentage } = await calculateCommission({
      chargesIn: values?.marginIn,
      amountValue:
        values?.marginIn === 'Absolute'
          ? values?.marginCost
          : values?.marginPercentage,
      sellingPrice: values?.sellingPrice ?? 0
    })

    return { marginIn, marginCost, marginPercentage }
  }

  return (
    <div className='row main_div'>
      <h5 className='mb-3 head_h3'>Pricing Details</h5>
      {toast?.show && (
        <CustomToast text={toast?.text} variation={toast?.variation} />
      )}

      {values?.isSizeWisePriceVariant &&
        allState?.sizeType?.length > 0 &&
        isAllowPriceVariant && (
          <>
            <div className='col-md-4 mb-3'>
              <div className='input-file-wrapper mb-3'>
                <label className='form-label required'>Size Value</label>
                <ReactSelect
                  id='productPrices'
                  name='productPrices'
                  isRequired
                  errors={!Array.isArray(errors) && errors}
                  touched={touched?.productPrices}
                  placeholder='Size Type'
                  value={
                    values?.sizeValueId && {
                      value: values?.sizeValueId,
                      label: values?.sizeValueName
                    }
                  }
                  options={values?.productPrices
                    ?.filter((data) => !data?.isDataInTable)
                    ?.map(({ sizeID, sizeName }) => ({
                      label: sizeName,
                      value: sizeID
                    }))}
                  onChange={(e) => {
                    handleSizeValuePriceVariant({
                      values,
                      resetForm,
                      size: { sizeValueId: e?.value, sizeValueName: e?.label }
                    })
                  }}
                />
              </div>
            </div>
            {!isAllowWarehouseManagement ? (
              <div className='col-md-4 mb-3'>
                <div className='input-file-wrapper mb-3'>
                  <FormikControl
                    disabled={!isAllowWarehouseManagement ? false : true}
                    control='input'
                    label='Total Quantity'
                    value={values?.quantity}
                    id='qty'
                    type='number'
                    name='quantity'
                    placeholder='Quantity'
                    onChange={(e) => {
                      if (Number(e?.target?.value) >= 0) {
                        setFieldValue('quantity', e?.target?.value)
                      }
                    }}
                    onBlur={() => {
                      values = {
                        ...values,
                        marginIn: values?.marginIn ?? 'Absolute',
                        marginCost: values?.marginCost,
                        marginPercentage: values?.marginPercentage
                      }
                      values = {
                        ...values,
                        productPrices: updateProductPrices(values)
                      }

                      resetForm({
                        values,
                        productPrices: values?.productPrices?.length
                          ? values?.productPrices?.map((data) => {
                              if (data?.sizeID === values?.sizeValueId) {
                                return {
                                  ...data,
                                  mrp: '',
                                  sellingPrice: '',
                                  discount: '',
                                  quantity: values?.quantity,
                                  isCheckedForQty: true
                                }
                              } else {
                                return {
                                  ...data,
                                  isCheckedForQty: false
                                }
                              }
                            })
                          : []
                      })
                    }}
                  />
                </div>
              </div>
            ) : (
              <div className='col-md-4 mb-3'></div>
            )}

            <div className='col-md-4 mb-3'></div>
          </>
        )}
      <div className='col-md-4  mb-3'>
        <label className='form-label required' htmlFor='mrp'>
          MRP
        </label>
        <InputGroup>
          <frm.Control
            maxLength={7}
            id='mrp'
            placeholder='MRP'
            value={values?.mrp}
            onChange={(e) => {
              const inputValue = e.target.value
              const regex = /^(?:\d*\.\d+|\d+\.?|\.)$/
              if (inputValue === '' || regex.test(inputValue)) {
                setFieldValue('mrp', inputValue)
              }
            }}
            onBlur={() => {
              let { mrp, sellingPrice, discount, error } = calculatePrices(
                values?.mrp,
                values?.sellingPrice,
                values?.discount,
                'mrp'
              )

              if (error) {
                showToast(toast, setToast, {
                  data: {
                    message: error,
                    code: 204
                  }
                })
              }

              values = {
                ...values,
                mrp,
                sellingPrice,
                discount
              }

              let productPrices = updateProductPrices(values)

              values = { ...values, productPrices }

              resetForm({ values })
            }}
          />
          <InputGroup.Text>{currencyIcon}</InputGroup.Text>
        </InputGroup>
        <ErrorMessage name='mrp' component={TextError} />
      </div>

      <div className='col-md-4  mb-3'>
        <label className='form-label required' htmlFor='sell'>
          Selling Price
        </label>
        <InputGroup>
          <frm.Control
            maxLength={7}
            id='sellingPrice'
            name='sellingPrice'
            placeholder='Selling price'
            value={values?.sellingPrice}
            onBlur={async () => {
              let { mrp, sellingPrice, discount, error } = calculatePrices(
                values?.mrp,
                values?.sellingPrice,
                values?.discount,
                'sellingPrice'
              )

              if (error) {
                showToast(toast, setToast, {
                  data: {
                    message: error,
                    code: 204
                  }
                })
              }

              values = {
                ...values,
                mrp,
                sellingPrice,
                discount
              }

              let { marginIn, marginCost, marginPercentage } =
                await updateCommission(values)

              values = { ...values, marginIn, marginCost, marginPercentage }

              let productPrices = updateProductPrices(values)

              values = { ...values, productPrices }

              resetForm({ values })
            }}
            onChange={(e) => {
              const inputValue = e.target.value
              const regex = /^(?:\d*\.\d+|\d+\.?|\.)$/
              if (inputValue === '' || regex.test(inputValue)) {
                setFieldValue('sellingPrice', inputValue)
              }
            }}
          />
          <InputGroup.Text>{currencyIcon}</InputGroup.Text>
        </InputGroup>
        <ErrorMessage name='sellingPrice' component={TextError} />
      </div>

      <div className='col-md-4 mb-3'>
        <label className='form-label required' htmlFor='discount'>
          Discount
        </label>
        <InputGroup>
          <frm.Control
            id='discount'
            name='discount'
            value={values?.discount}
            placeholder='Discount'
            onBlur={async () => {
              let { mrp, sellingPrice, discount, error } = calculatePrices(
                values?.mrp,
                values?.sellingPrice,
                values?.discount,
                'discount'
              )

              if (error) {
                showToast(toast, setToast, {
                  data: {
                    message: error,
                    code: 204
                  }
                })
              }

              values = {
                ...values,
                mrp,
                sellingPrice,
                discount
              }

              let { marginIn, marginCost, marginPercentage } =
                await updateCommission(values)

              values = { ...values, marginIn, marginCost, marginPercentage }

              let productPrices = updateProductPrices(values)

              values = { ...values, productPrices }

              resetForm({ values })
            }}
            onChange={(e) => {
              const inputValue = e.target.value
              if (inputValue === '' || _percentageRegex_.test(inputValue)) {
                setFieldValue('discount', inputValue)
              }
            }}
          />
          <InputGroup.Text>%</InputGroup.Text>
        </InputGroup>
        <ErrorMessage name='discount' component={TextError} />
      </div>
      {isMarginOnProductLevel && (
        <>
          <div className='col-md-4  mb-3'>
            <label className='form-label required' htmlFor='marginIn'>
              Margin In
            </label>
            <ReactSelect
              id='marginIn'
              name='marginIn'
              placeholder='Margin In'
              value={
                values?.marginIn && {
                  label: values?.marginIn,
                  value: values?.marginIn
                }
              }
              onChange={(e) => {
                setFieldValue('marginIn', e?.value)
              }}
              onBlur={async () => {
                let { marginIn, marginCost, marginPercentage } =
                  await updateCommission(values)

                values = { ...values, marginIn, marginCost, marginPercentage }

                let productPrices = updateProductPrices(values)

                values = { ...values, productPrices }

                resetForm({ values })
              }}
              options={chargesIn}
            />
          </div>

          <div className='col-md-4  mb-3'>
            <label className='form-label required' htmlFor='marginCost'>
              Margin Cost
            </label>
            <InputGroup>
              <frm.Control
                id='marginCost'
                placeholder='Margin Cost'
                disabled={values?.marginIn === 'Percentage' ? true : false}
                value={values?.marginCost}
                onBlur={async () => {
                  let { marginIn, marginCost, marginPercentage } =
                    await updateCommission(values)

                  values = { ...values, marginIn, marginCost, marginPercentage }

                  let productPrices = updateProductPrices(values)

                  values = { ...values, productPrices }

                  resetForm({ values })
                }}
                onChange={(e) => {
                  const inputValue = e.target.value
                  const regex = /^[0-9\b]+$/
                  if (inputValue === '' || regex.test(inputValue)) {
                    if (inputValue < values?.sellingPrice) {
                      setFieldValue('marginCost', e?.target?.value)
                    }
                  }
                }}
              />
              <InputGroup.Text>{currencyIcon}</InputGroup.Text>
            </InputGroup>
          </div>

          <div className='col-md-4 mb-3'>
            <label className='form-label required' htmlFor='marginPercentage'>
              Margin Percentage
            </label>
            <InputGroup>
              <frm.Control
                name='marginPercentage'
                id='marginPercentage'
                disabled={values?.marginIn === 'Absolute' ? true : false}
                value={
                  isNaN(values?.marginPercentage)
                    ? ''
                    : values?.marginPercentage
                }
                placeholder='Discount'
                onBlur={async () => {
                  let { marginIn, marginCost, marginPercentage } =
                    await updateCommission(values)

                  values = { ...values, marginIn, marginCost, marginPercentage }

                  let productPrices = updateProductPrices(values)

                  values = { ...values, productPrices }

                  resetForm({ values })
                }}
                onChange={(e) => {
                  const inputValue = e.target.value
                  const isValid = _percentageRegex_.test(inputValue)
                  if (inputValue === '' || isValid) {
                    if (inputValue <= 100) {
                      setFieldValue('marginPercentage', inputValue)
                    }
                  }
                }}
              />
              <InputGroup.Text>%</InputGroup.Text>
            </InputGroup>
          </div>
        </>
      )}
    </div>
  )
}

export default PricingDetails
